import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { determineStateData } from 'commons/utils'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const State = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const noBranchInvolved = useWatch({ control, name: `institutionActivitiesInfo.${index1 as 0}.noBranchInvolved` })
  const country = useWatch({
    control,
    name: `institutionActivitiesInfo.${index1 as 0}.institutionActivityBranchesInfo.${index2 as 0}.country`
  })
  const state = useWatch({
    control,
    name: `institutionActivitiesInfo.${index1 as 0}.institutionActivityBranchesInfo.${index2 as 0}.state`
  })
  const states = determineStateData(country)

  // disable input if it has one option and it's selected
  const isDisabled = states.length === 1 && state === states[0].value

  return (
    <Controller
      name={`institutionActivitiesInfo.${index1 as 0}.institutionActivityBranchesInfo.${index2 as 0}.state`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="72. State"
          input={(props) => (
            <Select
              {...props}
              data={states}
              emptyOption={{ label: 'Not selected', value: '' }}
              disabled={noBranchInvolved || isDisabled}
              data-qa="72. State"
              options-data-qa="72. State option"
            />
          )}
        ></FF2>
      )}
    />
  )
}
